import React from 'react';
import { useI18n } from '../../../context/I18nContext';
import EmptyState from '../../../shared/ui/EmptyState';
import './event-switcher.css';

type EventLike = { id?: string; name?: string; title?: string };

type EventSwitcherProps = {
    events: EventLike[];
    selectedEventId: string;
    onChange: (eventId: string) => void;
    /** Varsayilan: yalnizca 2+ etkinlikte gorunur. */
    alwaysShow?: boolean;
    /** Verilirse listenin basina bu metinle bos degerli ("tum etkinlikler") secenek eklenir. */
    allLabel?: string;
    label?: string;
    className?: string;
};

/**
 * Ortak etkinlik filtresi (cok-aktif etkinlik). 1 etkinlik varsa gizlenir,
 * 2+ etkinlikte tasarima uyumlu bir secim kutusu gosterir. PageHeader'in
 * `actions` alanina ya da liste ustune konur.
 */
const EventSwitcher = ({ events, selectedEventId, onChange, alwaysShow = false, allLabel, label, className = '' }: EventSwitcherProps) => {
    const { t } = useI18n();
    if (!events || events.length === 0) return null;
    if (events.length < 2 && !alwaysShow) return null;

    const text = label ?? t('activeEvents.label');
    return (
        <label className={`beetinq-event-switcher ${className}`.trim()}>
            <span className="beetinq-event-switcher-icon" aria-hidden="true">
                <i className="fa-regular fa-calendar" />
            </span>
            <span className="visually-hidden">{text}</span>
            <select
                className="beetinq-event-switcher-select form-select"
                aria-label={text}
                value={selectedEventId}
                onChange={(event) => onChange(event.target.value)}
            >
                {allLabel ? <option value="">{allLabel}</option> : null}
                {events.map((event) => (
                    <option key={String(event.id)} value={String(event.id)}>
                        {event.name || event.title || String(event.id)}
                    </option>
                ))}
            </select>
        </label>
    );
};

export const NoActiveEventNotice = ({ className = '' }: { className?: string }) => {
    const { t } = useI18n();
    return (
        <EmptyState
            className={className}
            icon="fa-regular fa-calendar-xmark"
            title={t('activeEvents.empty.title')}
            description={t('activeEvents.empty.description')}
            action={{ label: t('activeEvents.empty.action'), to: '/event' }}
        />
    );
};

export default EventSwitcher;
